export function isValidImageSrc(src) {
  if (src === null || src === undefined || src === '') {
    return false
  }
  if (typeof src === 'string') {
    const trimmed = src.trim()
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
      return false
    }
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/image.js